// theme.ts or theme.js
import { createTheme } from "@material-ui/core";

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, Arial, sans-serif',
  },
});

export default theme;
